const topNavigation = () => {

    const topNav            = $('.top-navigation');
    const element           = $('.js-nav-element');
    const elementActive     = element.find('.secondary-navigation__link._active');
    const primaryLink       = $('.js-top-nav-element');
    const secondaryLink     = $('.js-sec-nev-element');
    const activeClass       = 'top-navigation__level--active';
    const dropdownLink      = $('.js-dropdown-link');
    const activeTabsClass   = '_active';
    var timer;

    //move marker to active link
    if ( elementActive.length ) {
        animateMarker(elementActive.parents('.js-nav-element'));
    }
    primaryLink.on('mouseenter mouseleave', function(e){
        const _this = $(this);

        if ( e.type === 'mouseenter' ) {
            if (!!timer) {
                clearTimeout(timer);
            }
        }
        else if ( e.type === 'mouseleave' ) {
            let id = $(this).attr('data-top-element');

            if ( !$('[data-sec-element="'+ id +'"]').find('.secondary-navigation__link._active').length ) {
                const el = $('.secondary-navigation__link._active');

                if ( el.length ) {
                    const parent = el.parents('.js-nav-element');
                    const _id    = parent.attr('data-sec-element');

                    timer = setTimeout(function(){
                        animateMarker(parent);
                        //$(this).removeClass(activeClass);
                        _this.removeClass(activeClass);
                        $('[data-top-element='+_id+']').addClass(activeClass);
                    }, 200);
                }
            }
        }
    });
    element.on('mouseenter mouseleave', function(e){
        const id = $(this).attr('data-sec-element');

        if ( e.type === 'mouseenter' ) {

            if (!!timer) {
                clearTimeout(timer);
            }

            animateMarker($(this));
            primaryLink.removeClass(activeClass);
            $('[data-top-element='+id+']').addClass(activeClass);
        }
        else if ( e.type === 'mouseleave' ) {
            if ( !$(this).find('.secondary-navigation__link._active').length ) {
                const el = $('.secondary-navigation__link._active');

                if ( el.length ) {
                    const parent = el.parents('.js-nav-element');
                    const _id    = parent.attr('data-sec-element');

                    timer = setTimeout(function(){
                        animateMarker(parent);
                        primaryLink.removeClass(activeClass);
                        $('[data-top-element='+_id+']').addClass(activeClass);
                    }, 200);
                }
            }
            else {}
        }
    });

    //change tabs :: 3rd level
    dropdownLink.on('click', function(){
        let parent  = $(this).parents('.js-dropdown');
        let id      = $(this).attr('data-tabs-link');


        if ( !$(this).hasClass(activeTabsClass) ) {
            parent.find('.js-dropdown-link').removeClass(activeTabsClass);
            $(this).addClass(activeTabsClass);
            parent.find('.js-dropdown-inside').removeClass(activeTabsClass);
            parent.find('[data-tabs-id='+id+']').addClass(activeTabsClass);
        }
    });

}

const animateMarker = (el) => {
    const navigation = $('.js-secondary-navigation');
    const marker     = $('.js-nav-marker');
    const width      = el.width();
    const left       = el.offset().left - navigation.offset().left;

    marker.css({
        'left'  : left,
        'width' : width
    });
}